import { BannerProps } from "./models/BannerProps";
import { Banner } from "./styles/styles";

export const BannerMessage = ({
    message
}: BannerProps) =>
    <Banner style={{ display: 'flex', alignItems: 'center' }}>
        {message.text}
    </Banner>